import { useContext } from 'react';

import WaitListButton from '../utils/WaitlistButton';
import { BookGroupButton } from './GroupAvailability';
import RequiresAuthButton from '@website/components/auth/RequiresAuthButton';
import { Store } from '@website/Store';
import { FetchUsersWaitListQuery } from '@website/types/graphqlOperations';


interface GroupSpacesRemainingProps {
  remainingSpaces: number;
  groupID: string;
  userWaitList: FetchUsersWaitListQuery['user']['waitList']['items'];
}
/**
 * Display book button and spaces remaining
 */

export function GroupSpacesRemaining({
  remainingSpaces,
  groupID,
  userWaitList,
}: GroupSpacesRemainingProps) {
  const { state } = useContext(Store);
  if (remainingSpaces <= 0) {
    return (
      <div className="trip-quantity-inner">
        <RequiresAuthButton
          loginButtonTitle={
            <>
              Wait
              <br className="d-md-none" />
              list
            </>
          }
          buttonSize="sm"
          loginBtnVariant="light"
        >
          <WaitListButton
            groupID={groupID}
            userID={state.user.id}
            waitList={userWaitList}
          />
        </RequiresAuthButton>
        <p className="remaining-spaces text-muted remaining-spaces-0">
          Fully booked
        </p>
      </div>
    );
  }

  if (remainingSpaces <= 3) {
    return (
      <div className="trip-quantity-inner">
        <BookGroupButton groupID={groupID} />
        <p className="text-danger remaining-spaces">
          Just {remainingSpaces} space{remainingSpaces > 1 ? 's' : null}
          <br /> remaining
        </p>
      </div>
    );
  }

  if (remainingSpaces <= 5) {
    return (
      <div className="trip-quantity-inner">
        <BookGroupButton groupID={groupID} />
        <p className="text-warning remaining-spaces">
          {remainingSpaces} spaces
        </p>
      </div>
    );
  }

  return (
    <div className="trip-quantity-inner">
      <BookGroupButton groupID={groupID} />
      <p className="remaining-spaces">{remainingSpaces} spaces</p>
    </div>
  );
}
